import { constants } from '@bedc/constants';

import { Request } from '../../../../api/transaction/search/Request';

import { SearchDataTableType } from './SearchDataTableType';

export const TransactionType = SearchDataTableType({
	request: Request,
	columnFields: constants.transaction.search.columnFields,
	filterIds: constants.job.search.filterIds,
});
